<div fxFlex fxLayoutAlign="center" fxLayout="column" class="content-container">
	<h1>404</h1>
	<h2>{{ 'errors.page-not-found' | translate }}</h2>
	<p>
		<a [routerLink]="['/']">{{ 'shared.actions.back-to-dashboard' | translate }}</a>
	</p>
</div>
